<template>
  <!-- Schedule_ -->
  <div class="main" id="sched">
    <div class="row">
      <div class="banner_schedule pc">
        <span>会议日程</span>
        <h1 class="sch_h1">{{global.config[area_id].title}}</h1>
        <p class="sch_p1">{{global.config[area_id].trueplace}}</p>
        <p class="sch_p" v-if="days.length>0">{{getTheDay(days[0], "Y.M.D")}}~{{getTheDay(days[days.length-1], "D")}}</p>
        <p class="sch_p" v-else>敬请期待</p>
      </div>
      <div class="wap_banner_schedule mob">
        <h1 class="sch_h1 sch_wap_h1">{{global.config[area_id].year + global.config[area_id].title + "站MPD日程"}}</h1>
        <p class="sch_p1">{{global.config[area_id].trueplace}}</p>
        <p class="sch_p">{{getTheDay(days[0], "Y.M.D")}}~{{getTheDay(days[days.length-1], "Y.M.D")}}</p>
      </div>
    </div>
    <div class="richengall pc">
      <div class="richeng row ">
        <!-- <ul class="content content_pc row"></ul> -->
        <ul class="content content_pc row">
          <!-- 2020 成都 及之后的 MPD -->
          <slot v-if="area_id >= '2252'">
            <slot v-for="(item,index) in days">
              <h1 :key="'day_h1'+index">{{getTheDay(item, "Y年M月D日")}}</h1>
              <li class="show" :key="'day_li'+index">
                <!-- shangwu / xiawu -->
                <div v-for="(ap) in ap" :key="ap+'_'+index" :class="(ap=='am')?'shangwu':'xiawu'">
                  <table class="title">
                    <!-- top 匹配关键字 -->
                    <tr class="top">
                      <td style="text-align: center;">
                        <img src="../../static/images/sch_time.png" />
                      </td>
                      <slot v-for="(n) in size[index]">
                        <!-- {{ schedule.finishing[item][n+ap].name }} -->
                        <td :key="ap+'huichang_'+index+'_'+n"
                            :class="`huichang${matchKey(schedule.finishing[item][n+ap].name, schedule.finishing[item][n+ap].groupName)}`"
                             v-if="matchKey(schedule.finishing[item][n+ap].name, schedule.finishing[item][n+ap].groupName)>0">
                          <img :src="`../../static/images/richeng/rc_0${matchKey(schedule.finishing[item][n+ap].name, schedule.finishing[item][n+ap].groupName)}.png`" class="rc_img" />
                          <!-- <h2 v-html="schedule.finishing[item][n+ap].name.replace('/','<br>')+'<br>'"></h2> -->
                          <h2 v-html="schedule.finishing[item][n+ap].name+'<br>'"></h2>
                        </td>
                        <td :key="ap+'huichang_'+index+'_'+n" v-else>
                          <img :src="'../../static/images/richeng/rc_0'+n+'.png'" class="rc_img" />
                          <h2 v-html="schedule.finishing[item][n+ap].name+'<br>'"></h2>
                        </td>
                      </slot>
                    </tr>
                    <!-- kecheng -->
                    <!-- MPD 部分过滤第2日下午第2场数据 -->
                    <slot v-for="(titem,tindex) in times[ap]">
                      <tr class="kecheng" :key="ap+'time_'+index+'_'+tindex"
                          v-if="!(checkAreaId(area_id)&&index==1&&ap=='pm'&&tindex==times[ap].length-1)">
                        <td>
                          <b>{{getTheDay(item, "Y/M/D")}}<br>{{getWeekDay(item, "Y/M/D")}}</b><br><br>
                          {{schedule.timesData[titem][0]}}
                          <br>-<br>
                          {{schedule.timesData[titem][1]}}
                        </td>
                        <td valign="top" v-for="(n) in size[index]" :key="ap+'kecheng_'+index+'_'+n">
                          <a v-if="schedule.datas[item][ap][titem][n]" target="_blank"
                             :href="`/course?sid=${schedule.datas[item][ap][titem][n].sid}&id=${schedule.datas[item][ap][titem][n].courseId}${global.qd?('&qd='+global.qd):''}`">
                             <!-- @click.prevent="$router.push({path:'/course',name:'Course',query:{sid:schedule.datas[item][ap][titem][n].sid, id:schedule.datas[item][ap][titem][n].courseId}})"> -->
                            <div class="biaoti">{{schedule.datas[item][ap][titem][n].courseTitle}}</div>
                            <div class="ren">
                              <h2>{{schedule.datas[item][ap][titem][n].lecturers[0].name}}</h2>
                              <p>
                                {{schedule.datas[item][ap][titem][n].lecturers[0].company}}<br>
                                {{schedule.datas[item][ap][titem][n].lecturers[0].position}}
                              </p>
                            </div>
                          </a>
                          <div v-else style="text-align: center;line-height: 180px;">敬请期待</div>
                        </td>
                      </tr>
                    </slot>
                  </table>
                </div>
              </li>
            </slot>
          </slot>
        </ul>
      </div>
    </div>
    <div class="mob row wap_richeng">
      <!-- 2020 成都 及之后的 MPD -->
      <slot v-if="area_id >= '2252'">
        <ul class="wap_daohang row">
          <slot v-for="(n) in size[0]" >
            <li :key="'wap_daohang_'+n"
                @click="wap_num=n; this.$forceUpdate();" :id="n"
                :class="`active_ri${matchKey(schedule.finishing[days[0]][n+'am'].name, schedule.finishing[days[0]][n+'am'].groupName)} col-xs-6 col-sm-6 ${n==wap_num ? 'active_ri' : ''}`">
                {{schedule.finishing[days[0]][n+'am'].name}}
            </li>
          </slot>
        </ul>
        <ul class="wap_content row">
          <li class="show">
            <slot v-for="(day,dayindex) in days">
              <h6 :key="'wap_day_h6_'+dayindex">{{getTheDay(day, "Y/M/D")}} {{getWeekDay(day, "Y/M/D")}}</h6>
              <div :key="'wap_day_div_'+dayindex" class="rad row">
                <slot v-for="(ap,apindex) in ap">
                  <slot v-for="(time,timeindex) in times[ap]">
                    <slot v-for="(n) in size[dayindex]">
                      <div v-if="n==wap_num" :key="'wapCourse_'+apindex+'_'+timeindex+'_'+n" class="col-sm-12 col-xs-12">
                        <a v-if="schedule.datas[day][ap][time] && schedule.datas[day][ap][time][n]"
                           @click.prevent="$router.push({path:'/course',name:'Course',query:{sid:schedule.datas[day][ap][time][n].sid, id:schedule.datas[day][ap][time][n].courseId}})">
                          <h2>{{schedule.datas[day][ap][time][n].courseTitle}}</h2>
                          <div>
                            <div class="img"></div>
                            <div class="wenz">
                              <p>
                                {{schedule.datas[day][ap][time][n].lecturers[0].name}}
                                <span>
                                  {{schedule.datas[day][ap][time][n].lecturers[0].company}}{{schedule.datas[day][ap][time][n].lecturers[0].position}}
                                </span>
                              </p>
                              <span class="glyphicon glyphicon-time title_time"></span>
                              <span class="time">
                                {{schedule.timesData[time][0]}}~{{schedule.timesData[time][1]}}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </slot>
                  </slot>
                </slot>
              </div>
            </slot>
          </li>
        </ul>
      </slot>
      <slot v-else>
        <ul class="wap_daohang row"></ul>
        <ul class="wap_content row"></ul>
      </slot>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import $ from 'jquery'

export default {
  name: 'Schedule',
  data () {
    return {
      area_id: '',
      days: [],
      times: {am: [], pm: []},
      size: [],
      ap: ['am', 'pm'],
      wap_num: 1,
      schedule: []
    }
  },
  created () {
    this.area_id = this.global.area_id
    if (this.$route.query.sid) {
      this.area_id = this.$route.query.sid
    }
    this.area_id = this.area_id.toString()
    if (this.area_id < 2252) { // 2021之前的MPD 2252
      // window.location.href = '../static/2020MPD/schedule.html?sid=' + this.area_id
      window.open(`/static/2020MPD/schedule.html?sid=${this.area_id}`, '_self')
    }
    this.getSchedule()
  },
  methods: {
    getTheDay (d, s) {
      return this.global.formatTime(d, s)
    },
    getWeekDay (d, s) {
      function getWeek (date) {
        var week
        if (date.getDay() === 0) week = '星期日'
        if (date.getDay() === 1) week = '星期一'
        if (date.getDay() === 2) week = '星期二'
        if (date.getDay() === 3) week = '星期三'
        if (date.getDay() === 4) week = '星期四'
        if (date.getDay() === 5) week = '星期五'
        if (date.getDay() === 6) week = '星期六'
        return week
      }
      return getWeek(new Date(this.global.formatTime(d, s)))
    },
    matchKey (title, name) {
      let flag = 0
      if (name && name.length > 0) {
        if (name.includes('产品') || name.includes('运营')) {
          flag = 1
        } else if (name.includes('团队') || (name.includes('管理') && !name.includes('测试'))) {
          flag = 2
        } else if (name.includes('架构') || name.includes('战略')) {
          flag = 3
        } else if (name.includes('数据') || name.includes('人工智能') || name.includes('开发')) {
          flag = 4
        } else if (name.includes('测试') || name.includes('运维') || name.includes('DevOps') || name.includes('前端')) {
          flag = 5
        }
      }
      if (flag === 0 && title && title.length > 0) {
        if (title.includes('产品') || title.includes('运营')) {
          flag = 1
        } else if (title.includes('团队') || (title.includes('管理') && !title.includes('测试'))) {
          flag = 2
        } else if (title.includes('架构') || title.includes('战略')) {
          flag = 3
        } else if (title.includes('数据') || title.includes('人工智能') || title.includes('开发')) {
          flag = 4
        } else if (title.includes('测试') || title.includes('运维') || title.includes('DevOps') || title.includes('前端') || title.includes('工程实践')) {
          flag = 5
        }
      }
      // console.log(title, flag)
      return flag
    },
    getSchedule: function () {
      // 获取全部会议信息
      var area_id = this.area_id
      var url_schedule = this.global.url.schedule + area_id
      if (!this.global.config[area_id]) {
        console.log('不存在')
      }
      this.$http
        .jsonp(url_schedule)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log(data);
          this.schedule = []
          if (data.errno && data.errno.toString() === '0') {
            this.schedule = data.data
            this.days = Object.keys(data.data.datas)
            let times = Object.keys(data.data.timesData)
            let times_length = times.length
            for (let i = 0; i < times_length; i++) {
              if (times[i].split(':')[0] < 12) {
                this.times['am'].push(times[i])
              }
              if (times[i].split(':')[0] > 12) {
                this.times['pm'].push(times[i])
              }
            }
            for (let i = 0; i < this.days.length; i++) {
              let arr = Object.keys(data.data.finishing[this.days[i]])
              // if (JSON.stringify(arr).split('am') !== -1 && JSON.stringify(arr).split('pm') !== -1) {
              if (JSON.stringify(arr).indexOf('am') !== -1 && JSON.stringify(arr).indexOf('pm') !== -1) {
                this.size.push(parseInt(arr.length / 2))
                // this.size.push(Math.ceil(arr.length/2));
              }
            }
            // console.log(this.size);
            // console.log(area_id,this.size,this.days,this.times,this.schedule);
          } else {
            console.log('请求错误')
          }
        })
    },
    checkAreaId: function (area_id) {
      // 2021天津/北京/广州/成都 2022北京 —— 不含第2日下午第2场数据的大会
      let arr = ['2690', '2721', '2940', '2942', '3357', '4224']
      if (arr.indexOf(area_id) > -1) {
        return true
      }
      return false
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Schedule.vue